import { useRef, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const TAB_ORDER: Record<string, number> = {
  '/': 0,
  '/friends': 1,
  '/messages': 2,
};

function getTabIndex(pathname: string): number {
  return TAB_ORDER[pathname] ?? -1;
}

export function AnimatedOutlet() {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const directionRef = useRef<'right' | 'left'>('right');

  useEffect(() => {
    const prevIndex = getTabIndex(prevPathRef.current);
    const currIndex = getTabIndex(location.pathname);

    if (prevIndex !== -1 && currIndex !== -1 && prevIndex !== currIndex) {
      directionRef.current = currIndex > prevIndex ? 'right' : 'left';
    }

    prevPathRef.current = location.pathname;
  }, [location.pathname]);

  const isTab = getTabIndex(location.pathname) !== -1;
  const animationClass = isTab ? `animate-slide-in-${directionRef.current}` : '';

  return (
    <div key={location.pathname} className={animationClass}>
      <Outlet />
    </div>
  );
}
